const accessRight = { none: 0, read: 1, edit: 3, full: 7,}
const accessRightActions=  ['index', 'view', 'create', 'update', 'delete'];

export { accessRight, accessRightActions }
